import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { isVerticalIpadMini } from '../../common/responsiveUtils';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

// 線区と区間の入力フォーム
const SectionAndStationForm = (props) => {
  return (
    <Select
      sx={{ width: isVerticalIpadMini() ? '200px' : '240px', height: '44px' }}
      value={props.value}
      onChange={props.onChange}
      displayEmpty
      MenuProps={{ sx: { maxHeight: '300px' } }}
      renderValue={(selected) => {
        if (!selected) {
          return '選択する';
        }
        const name = props.menuItems.find((data) => data.code === selected)?.name;
        return name;
      }}
    >
      {props.menuItems?.map((data) =>
        <MenuItem key={data.code} value={data.code}>
          {data.name}
        </MenuItem>,
      )}
    </Select>
  );
};

// 通告・通告テンプレートの作成で使用する「線区」と「区間」
const SectionAndStationSelects = (props) => {
  const { index, notice, masterData } = props;
  const { sectionCode, startStationCode, endStationCode } = notice;
  const { typography } = useTheme();
  const styles = {
    label: { ...typography.caption13bold, marginBottom: '8px', color: 'secondary.main' },
  };

  const getStationName = (code) => {
    return masterData.find((section) => section.code === notice.sectionCode)?.stations
      .find((stations) => stations.code === code)?.name;
  };

  return (
    <Stack direction='row' marginBottom='36px'>
      {/* 線区 */}
      <Stack marginRight='36px'>
        <FormControl>
          <FormLabel required sx={styles.label}>線区</FormLabel>
          <SectionAndStationForm
            value={sectionCode}
            onChange={(event) => {
              const code = event.target.value;
              props.handleChange(
                {
                  sectionCode: code,
                  sectionName: masterData.find((section) => section.code === code).name,
                  startStationCode: '',
                  endStationCode: '',
                },
                index);
            }}
            menuItems={masterData}
          />
        </FormControl>
      </Stack>

      {/* 区間 */}
      <Stack>
        <FormLabel required sx={styles.label}>区間</FormLabel>
        <Stack direction='row'>
          <FormControl >
            <SectionAndStationForm
              value={startStationCode}
              onChange={(event) => {
                props.handleChange(
                  {
                    startStationCode: event.target.value,
                    startStationName: getStationName(event.target.value),
                  },
                  index);
              }}
              menuItems={masterData.find((elm) => elm.code === sectionCode)?.stations}
            />
          </FormControl>
          <Typography variant='body16' padding='8px' margin='auto'>
            〜
          </Typography>
          <FormControl >
            <SectionAndStationForm
              value={endStationCode}
              onChange={(event) => {
                props.handleChange(
                  {
                    endStationCode: event.target.value,
                    endStationName: getStationName(event.target.value),
                  },
                  index);
              }}
              menuItems={masterData.find((elm) => elm.code === sectionCode)?.stations}
            />
          </FormControl>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SectionAndStationSelects;

SectionAndStationForm.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  menuItems: PropTypes.array,
};

SectionAndStationSelects.propTypes = {
  index: PropTypes.number,
  notice: PropTypes.object,
  handleChange: PropTypes.func,
  masterData: PropTypes.array,
};
